import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireBundle } from "C:\\xampp\\htdocs\\showa\\wp-content\\themes\\showa\\src\\js\\bundle\\index.js";
var bundleExports = requireBundle();
export { bundleExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(bundleExports);